<script>
import { DEFAULT_CURRENT_PAGE, DEFAULT_PAGE_SIZE } from '@src/mixins/pagination'
const INIT_PAGE_SIZE_RANGE = [10 ,20 ,50, 100]
export default {
  props: {
    currentPage: {
      type: Number,
      default: DEFAULT_CURRENT_PAGE,
    },
    pageSize: {
      type: Number,
      default: DEFAULT_PAGE_SIZE,
    },
    showSize: {
      type: Boolean,
      default: false
    },
    /**
     * @description 讓選擇分頁消失
     */
    selectMiniNone: {
      type: Boolean,
      default: false
    },
    /**
     * @description 讓跳分頁按鈕照column排列
     */
    displayColumn: {
      type: Boolean,
      default: false
    },
    /**
     * @description 外部傳進來的所有資料
     */
     propsTotal: {
      type: Number,
      default: 0
    },
  },
  watch: {
    /**
     * @description 如果有數字傳進來，則依照此數字total為準
     */
     propsTotal(nvl) {
      this.total = nvl
    },
  },
  data() {
    return {
      total: 0,
      pageSizeRange: [...INIT_PAGE_SIZE_RANGE],
      componentCurrentPage: 0, // component內使用的currentPage
    }
  },
  computed: {
    layoutType(total) {
      return this.showSize ? "sizes, prev, pager, next, jumper" : "prev, pager, next, jumper"
    }
  },
  mounted(){
    this.componentCurrentPage = this.currentPage 
  },
  methods: {
    updateTotal(total) {
      this.componentCurrentPage = 1
      this.total = total
      if(total > 100) {
        if(total % 100 !== 0) {
          const lastPage = Math.floor(total / 100) * 100 + 100
          this.pageSizeRange = [...INIT_PAGE_SIZE_RANGE, lastPage]
        } else {
          this.pageSizeRange = [...INIT_PAGE_SIZE_RANGE, total]
        }
      } else {
        this.pageSizeRange = [...INIT_PAGE_SIZE_RANGE]
      }
      this.$nextTick(()=>{
        this.componentCurrentPage = this.currentPage // componentCurrentPage純顯示，實際上動作打API還是currentPage
      })
    },
    /**
     * @description 改變現在的頁數（前面有.sync接）
     */
    updateCurrentPage(page) {
      this.$emit('update:currentPage', page)
    },
    /**
     * @description 改變每頁的大小（前面有.sync接）
     */
    sizeChange(value) {
      this.$emit('update:pageSize', value)
    }
  },
}
</script>

<template>
  <el-pagination ref="innerPagination" :class="[$style.wrapper, selectMiniNone ? $style.seleceMiniNone : '', displayColumn ? $style.displayColumn : '']"
    :current-page="componentCurrentPage" :page-sizes="pageSizeRange" :page-size="pageSize" :total="total"
    :layout="layoutType" background class="is-border pb-4" :hide-on-single-page="!showSize"
    @current-change="updateCurrentPage" @size-change="sizeChange">
  </el-pagination>
</template>

<style lang="scss" module>

.wrapper {
  margin-top: 15px;
  text-align: center;
  :global {
    @include max-sm {
      .btn-prev {
        width: 30px;
      }
    }
  }
}

.displayColumn {
  white-space: initial !important;
  :global {
    .el-pagination__jump {
      // margin-top: 10px;
      // margin-left: 0;
    }
  }
}

.seleceMiniNone {
  :global {
    .el-select--mini {
      display: none !important;
    }

    .el-pagination__jump {
      display: none !important;
    }
  }
}
</style>